
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "nemovitosti",
  "use": "nemovitosti-usage",
  "viewBox": "0 0 91.333 85.167",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 91.333 85.167\" id=\"nemovitosti\"><g fill=\"none\"><path d=\"M52.423 21.168v7.367a3.084 3.084 0 01-3.084 3.083h-9.42a3.082 3.082 0 01-3.084-3.083v-7.367M33.607 20.808l8.844-8.844a3.083 3.083 0 014.361 0l8.838 8.842M52.423 47.833v7.365a3.085 3.085 0 01-3.084 3.084h-9.42a3.082 3.082 0 01-3.084-3.084v-7.365M33.607 47.471l8.844-8.845a3.088 3.088 0 014.361 0l8.838 8.844\" /><g><path d=\"M29.677 34.503v7.363a3.085 3.085 0 01-3.084 3.085h-9.422a3.082 3.082 0 01-3.082-3.085v-7.363M10.859 34.14l8.844-8.845a3.085 3.085 0 014.359 0l8.842 8.844\" /></g><g><path d=\"M77.25 34.503v7.363a3.084 3.084 0 01-3.084 3.085h-9.424a3.083 3.083 0 01-3.082-3.085v-7.363M58.433 34.14l8.84-8.845a3.088 3.088 0 014.361 0l8.842 8.844\" /></g></g></symbol>"
});
    sprite.add(symbol);

    export default class NemovitostiSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="nemovitosti" {...this.props} />;
      }
    }
  